import { userDataType } from "../../../stores/accountManagementStore";
import { toast } from "react-toastify";
import { supabase } from "../../../context/useSupabaseContext";

export default async function signInWithPassword(
    email: string,
    password: string
): Promise<userDataType> {
    if (!email || !password || email.length < 3 || password.length < 5) {
        toast.error("Invalid email or password");
        return null;
    }

    // Create a promise that toast can track
    const loginPromise = async () => {
        // Use Supabase auth directly on client side
        const { data, error } = await supabase.auth.signInWithPassword({
            email,
            password,
        });

        if (error) {
            throw new Error(error.message);
        }

        if (!data.user || !data.session) {
            throw new Error('No user data returned');
        }

        // Get the session to extract tokens
        const session = data.session;

        // Transform Supabase user data to match your expected userData type
        const userData: userDataType = {
            id: data.user.id,
            email: data.user.email || '',
            providers: data.user.app_metadata?.providers || []
        };

        console.log(userData);
        return userData;
    };

    // Use toast.promise to handle all states
    try {
        const result = await toast.promise(
            loginPromise(),
            {
                pending: "Signing in...",
                success: "Successfully signed in!",
                error: "Failed to sign in"
            }
        );
        return result;
    } catch (err) {
        console.log("Login error:", err);
        return null;
    }
}
